import { call, put } from 'redux-saga/effects'
import { baseFetchToken } from './BaseSaga'
import TransferHistoryActions from '../Redux/TransferHistoryRedux'
import AuthActions from '../Redux/AuthRedux'
import { getToken } from '../Services/GetToken'

export function * getTransferHistory (api, action) {
  try {
    const token = yield call(getToken)
    if (!token) {
      yield put(AuthActions.authLogout())
    } else {
      const res = yield call(api.getTransferHistory, token, action.filter)
      if (!res.ok) {
        yield put(TransferHistoryActions.transferHistoryFailure('Terjadi kesalahan, ulangi beberapa saat lagi'))
      } else {
        if (!res.data.error) {
          let page = parseInt(res.data.meta.page, 10)
          let total = res.data.meta.count
          const data_with_page = {
            data: res.data.data,
            page,
            total
          }
          yield put(TransferHistoryActions.transferHistorySuccess(data_with_page))
        } else {
          yield put(TransferHistoryActions.transferHistoryFailure(res.data.message))
        }
      }
    }
  } catch (e) {
    yield put(TransferHistoryActions.transferHistoryFailure())
  }
}

export function * getTransferHistoryMatches (api, action) {
  yield baseFetchToken(api.getTransferHistoryMatches,
    null,
    getToken,
    TransferHistoryActions.transferHistoryMatchesSuccess,
    TransferHistoryActions.transferHistoryMatchesFailure)
}

export function * updateTransferHistory (api, action) {
  yield baseFetchToken(api.updateTransferHistory,
    action.data,
    getToken,
    TransferHistoryActions.transferHistoryUpdateSuccess,
    TransferHistoryActions.transferHistoryUpdateFailure)
}

export function * transferHistoryListSpreadsheet (api, action) {
  try {
    const token = yield call(getToken)
    if (!token) {
      yield put(AuthActions.authLogout())
    } else {
      const res = yield call(api.transferHistoryListSpreadsheet, token, action.filter)
      if (!res.ok) {
        yield put(TransferHistoryActions.transferHistoryListDownloadFailure('Terjadi kesalahan, ulangi beberapa saat lagi'))
      } else {
        if (!res.data.error) {
          yield put(TransferHistoryActions.transferHistoryListDownloadSuccess(res.data))
        } else {
          yield put(TransferHistoryActions.transferHistoryListDownloadFailure(res.data.message))
        }
      }
    }
  } catch (e) {
    yield put(TransferHistoryActions.transferHistoryListDownloadFailure())
  }
}



// WEBPACK FOOTER //
// ./src/Sagas/TransferHistorySagas.js